module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors,
      "useAuthentication": false
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order,
      "columns": 6
    }
  })], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Sincronização"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar estoque",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.stock),
      expression: "config.synchronize.stock"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "stock", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os estoques serão sincronizados e atualizados na Magalu.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar preço",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.price),
      expression: "config.synchronize.price"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "price", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os preços serão sincronizados e atualizados na Magalu.")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c4841b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Magalu.vue
// module id = 3141
// module chunks = 0